import { EventHelper } from "app/helpers/eventHelper";
import type { EventIncidentType, EventType } from "app/types/eventType";
import React, { useState } from "react";

type Props = {
  event: EventType;
  period: string;
  eventIncidents: EventIncidentType[];
};

const AsianEventScore: React.FC<Props> = ({
  event,
  period,
  eventIncidents,
}) => {
  const [homeScoreFullTime, setHomeScoreFullTime] = useState<number | null>(
    EventHelper.getHomeScore(
      eventIncidents[0][
        period === "fullTime" ? "scoreDetails" : "currentPeriodScoreDetails"
      ]
    )
  );
  const [awayScoreFullTime, setAwayScoreFullTime] = useState<number | null>(
    EventHelper.getAwayScore(
      eventIncidents[0][
        period === "fullTime" ? "scoreDetails" : "currentPeriodScoreDetails"
      ]
    )
  );

  if (homeScoreFullTime === null || awayScoreFullTime === null) {
    return null;
  }

  const score = event.showHomePlayerAsFirst
    ? `${homeScoreFullTime} - ${awayScoreFullTime}`
    : `${awayScoreFullTime} - ${homeScoreFullTime}`;

  return <div className="asian-event__score">{score}</div>;
};

export default AsianEventScore;
